import { safeBrand } from "@/lib/color";

/**
 * The merchant's logo, or their initial when they haven't set one.
 * `print` is how it looks on a receipt and in the vault: one colour of ink,
 * like a thermal printer would do it. Without it the real colours show, which
 * is what the merchant console wants so people can see what they uploaded.
 */
export function MerchantMark({
  name,
  logoUrl,
  color,
  print = false,
  priority = false,
  className = "size-12 rounded-lg",
}: {
  name: string;
  logoUrl: string | null;
  color: string;
  print?: boolean;
  /** the logo is what the customer is waiting for, so fetch it ahead of the fonts */
  priority?: boolean;
  className?: string;
}) {
  if (logoUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element -- tiny logo, the optimizer would only add latency
      <img
        src={logoUrl}
        alt=""
        width={48}
        height={48}
        fetchPriority={priority ? "high" : undefined}
        className={`flex-none object-contain ${print ? "logo-print" : ""} ${className}`}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={`flex flex-none items-center justify-center font-semibold ${className} ${print ? "bg-ink text-white" : ""}`}
      style={print ? undefined : { background: safeBrand(color), color: "#fff" }}
    >
      {name.slice(0, 1)}
    </span>
  );
}
